













import { Vue, Component, Prop } from 'vue-property-decorator';

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { STATUS } from '@/const/status';
import { IGridOptions, DefaultGridOptions, GroupColumnOptions, NumberColumnOptions, DefaultColumnOptions } from '@/const/options/TuiGridTypes';
import { TUI_FORMAT } from '@/utils/toastGrid_formatter';
import { AppReportsType, IAppReport } from '@/pages/report/inventory/types';

import { Grid } from '@toast-ui/vue-grid';
@Component<GridInventoryReport>({
    name: 'GridInventoryReport',
    components: {
        Grid,
    },
})
export default class GridInventoryReport extends Vue {
    @Prop({ type: Array, required: true }) private data!: AppReportsType;
    @Prop({ type: Boolean, default: false }) private loading!: boolean;
    @Prop({ type: String, required: true }) private dateFormat!: string;
    @Prop({ type: String, required: true }) private dateRangeFormat!: string;
    @Prop({ type: String, default: ' ~ ' }) private dateRangeSplitChar!: string;
    @Prop({ type: Boolean, default: false }) private isHourly!: boolean;

    private compTerms = compTerms;
    private gridOptions: IGridOptions = {
        ...DefaultGridOptions,
        treeColumnOptions: {
            useIcon: true,
            name: 'name',
            useCascadingCheckbox: false,
        },
        summary: {
            defaultContent: '',
            position: 'bottom',
            height: 40,
            columnContent: (() => {
                const t = {
                    name: { template: (summary: tuiGrid.IValueMap) => '<strong>TOTAL</strong>' },
                    totalRequest: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'totalRequest') },
                    adServerRequest: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'adServerRequest') },
                    adServerFreeRequest: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'adServerFreeRequest') },
                    sspRequest: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'sspRequest') },
                    totalImp: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'totalImp') },
                    adServerImp: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'adServerImp') },
                    adServerFreeImp: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'adServerFreeImp') },
                    sspImp: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'sspImp') },
                    adServerImpRate: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'calc', '%', 'adServerImpRate') },
                    click: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '회', 'click') },
                    ctr: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'calc', '%', 'ctr') },
                    revenue: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '원', 'revenue') },
                };
                if (this.isHourly) delete t.sspImp;
                return t;
            })()
        },
        header: {
            height: 80,
            complexColumns: [
                { 
                    title: '요청 수 _ 주문', name: 'mergeRequest',
                    childNames: ['totalRequest'/*,'adServerRequest', 'adServerFreeRequest', 'sspRequest'*/],
                },
                { 
                    title: '노출된 요청 수 _ 판매', name: 'mergeImp',
                    childNames: ['totalImp','adServerImp', 'adServerFreeImp', 'sspImp'],
                },
            ]
        },
        columns: [
            { title: compTerms.column.report.inventory.name, name: 'name',...GroupColumnOptions, formatter: this.formatNameWithStatus },
            { title: compTerms.column.date, name: 'date', minWidth: 200, align: 'center', formatter: this.formatDate},
            { title: compTerms.column.totalRequest, name: 'totalRequest', ...NumberColumnOptions, formatter: this.formatCount },
            // { title: compTerms.column.adServerRequest, name: 'adServerRequest', ...NumberColumnOptions, formatter: this.formatCount },
            // { title: compTerms.column.adServerFreeRequest, name: 'adServerFreeRequest', ...NumberColumnOptions, formatter: this.formatCount },
            // { title: compTerms.column.sspRequest, name: 'sspRequest', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.totalImp, name: 'totalImp', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.adServerImp, name: 'adServerImp', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.adServerFreeImp, name: 'adServerFreeImp', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.sspImp, name: 'sspImp', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.adServerImpRate + ' _ 판매율', name: 'adServerImpRate', ...NumberColumnOptions, formatter: this.formatRate },
            { title: compTerms.column.click, name: 'click', ...NumberColumnOptions, formatter: this.formatCount },
            { title: compTerms.column.ctr, name: 'ctr', ...NumberColumnOptions, formatter: this.formatRate },
            { title: compTerms.column.revenue + ' (eCPM)', name: 'revenue', ...DefaultColumnOptions, formatter: this.formatWithECPM },
        ].filter((v: tuiGrid.IColumnInfoOptions) => !(this.isHourly && v.name === 'sspImp'))
    };
    
    private summaryFormat(params: tuiGrid.IValueMap, property: string, unit: string, columnName: string): string {
        if ( property === 'calc' ) {
            if (columnName === 'ctr') {
                const imp = this.data.map((row: IAppReport) => Number(row.totalImp)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
                const click = this.data.map((row: IAppReport) => Number(row.click)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
                return '<strong>' + (imp > 0 ? TUI_FORMAT.NumberFormat( (click / imp) * 100) : ' - ') + '</strong>' + unit;
            } 
            if (columnName === 'adServerImpRate') {
                const totalRequest = this.data.map((row: IAppReport) => Number(row.totalRequest)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
                const adServerImp = this.data.map((row: IAppReport) => Number(row.adServerImp)).reduce((prev: number, curr: number) => prev + (curr > 0 ? curr : 0), 0);
                return '<strong>' + (totalRequest > 0 ? TUI_FORMAT.NumberFormat( (adServerImp / totalRequest) * 100) : ' - ') + '</strong>' + unit;
            }
        }
        params.sum = 0; params.avg = 0; params.min = Number.MAX_SAFE_INTEGER; params.max = Number.MIN_SAFE_INTEGER; params.cnt = 0;
        this.data.forEach((row: IAppReport) => {            
            const num = Number.parseFloat((row as any)[columnName]);
            if (!Number.isNaN(num)) {
                params.cnt++;
                if (num >= 0) {
                    params.sum += num;
                    if (params.max < num) params.max = num;
                    if (params.min > num) params.min = num;
                }
            }
        })
        if (params.max === Number.MIN_SAFE_INTEGER) params.max = 0;
        if (params.min === Number.MAX_SAFE_INTEGER) params.min = 0;
        params.avg = params.cnt === 0 ? 0 : params.sum / params.cnt;
        
        return TUI_FORMAT.SummaryFormat(params, property, unit);
    }
    
    private formatNameWithStatus(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue) {
            if (rowAttrs.hasOwnProperty('status')) {
                const status = rowAttrs.status as STATUS;
                if ( (status & STATUS.Deleted) ) return `<i class="deletedSign el-icon-delete"></i> ${cellValue}`;
                if ( (status & STATUS.ACTIVE) ) return `<i class="onSign"></i> ${cellValue}`;
                return `<i class="offSign"></i> ${cellValue}`;
            }
            return cellValue;
        } else {
            return ' - ';
        }
    }
    private formatDate(cellValue: Date | string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue) {
            return TUI_FORMAT.InRowDateFormat(cellValue as Date, this.dateFormat);
        } else if (rowAttrs.dateRange){
            return TUI_FORMAT.InRowDateRangeTagFormat(rowAttrs.dateRange as Date[], this.dateRangeFormat, this.dateRangeSplitChar);
        }
        return '';
    }
    private formatCount(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (cellValue !== undefined) {
            return TUI_FORMAT.NumberFormat(cellValue) + ' 회';
        }
        return ' - ';
    }
    private formatRate(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        const num = Number.parseFloat(cellValue);
        if (Number.isNaN(num) || num === -1) {
            return '- %';
        }
        return TUI_FORMAT.NumberFormat(cellValue) + ' %';
    }
    private formatWithECPM(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        const num = Number.parseFloat(cellValue);
        if (Number.isNaN(num)) {
            return 0 + ' (0 원)';
        }
        if (rowAttrs.totalImp) { // 0 or undefined check
            const imp = rowAttrs.totalImp as number;
            const eCPM = (num / imp) * 1000;
            return TUI_FORMAT.NumberFormat(cellValue) + ` (${TUI_FORMAT.NumberFormat(eCPM)} 원)`;
        }
        return TUI_FORMAT.NumberFormat(cellValue) + ` ( - 원)`
    }
    
    private expandedHandler({ rowKey, descendantRowKeys, instance }: tuiGrid.IColumnEventOptions & { descendantRowKeys: number[] | string[] | undefined[] }) {
        this.$emit('expanded', { rowKey, descendantRowKeys, instance });
    }
    private resizeHandler(event: Event) {
        this.$emit('resize', event);
    }
}
